import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = {
  path: '/new-cars',
  exact: true,
  page: getLoadablePage(() => import(/* webpackChunkName: "new_cars_landing" */ '../pages/index/index-definition')),
  chunkName: 'new_cars_landing',
  enableLooseEtag: true,
};
